import React from "react"
import badge from "badges/tactics-and-strategies.svg"
import { BadgeImage } from "backpack/badges/styled"

const TacticsAndStrategies = props => <BadgeImage src={badge} {...props} />

export default TacticsAndStrategies
